import {
  parseOptional,
  parseDecimal,
} from "@syla/shared/types/helpers/parsing";
import { TransportType } from "@syla/shared/types/helpers/TransportType";
import {
  OrderResponseItem,
  GroupBase,
} from "@syla/shared/types/responses/OrderResponseItem";
import { parseTransactionResponseItem } from "./parseTransactionResponseItem";

export function parseOrderResponseItem(
  data: TransportType<OrderResponseItem>,
): OrderResponseItem | undefined {
  if (!data.order || !data.transactions || !data.transactions.length) {
    console.error(`missing properties for order response item`, data);
    return undefined;
  }

  return {
    order: parseOrder(data.order),
    transactions: data.transactions.map((t) => parseTransactionResponseItem(t)),
    taxOutcome: parseOptional(data.taxOutcome, parseDecimal),
  };
}

export function parseOrder(order: TransportType<GroupBase>): GroupBase {
  return {
    ...order,
    date: new Date(order.date),
  };
}
